import {
  Button,
  ButtonProps,
  Stack,
  SxProps,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { ShareButton } from "components/Button"
import { useTranslation } from "react-i18next"
import { CloseIcon, PlaceIcon } from "components/icons"
import { useAppUI } from "providers/ui"
import { useCallback, useMemo } from "react"
import { getIcon } from "utils/icon"
import { deepmerge } from "@mui/utils"

export interface DirectionButtonProps {
  icon?: React.ReactNode
  label?: string
  isHidden?: boolean
  [key: string]: any
}

interface IFeatureActionContainerProps {
  sx?: SxProps
  ShareProps?: ButtonProps
  DirectionButtonProps?: DirectionButtonProps
  onNavigate: () => void
  isComingSoon: boolean
}

export const FeatureActionContainer = ({
  sx,
  ShareProps,
  DirectionButtonProps,
  onNavigate,
  isComingSoon = false,
}: IFeatureActionContainerProps) => {
  const { goBack } = useAppUI()
  const { t } = useTranslation()
  const {
    icon = <PlaceIcon />,
    label = "Directions",
    isHidden = false,
    ...restDirectionButtonProps
  } = DirectionButtonProps
  const isMobileOrTablet = useMediaQuery("(max-width: 991px)")
  const buttonSize = isMobileOrTablet ? "small" : "medium"
  const theme = useTheme()
  const {
    shortInfoActionWrapper,
    navigationButton,
    actionButton,
    comingSoonButton,
    backButton,
  } = theme.components[`FeatureActionContainer`]?.styleOverrides || {}

  const handleClickBack = useCallback(() => {
    goBack()
  }, [goBack])
  const closeIcon = useMemo(
    () => getIcon(theme?.assets?.placeDetailDrawer?.closeIcon) || <CloseIcon />,
    [theme]
  )

  return (
    <Stack
      className="FeatureActionContainer-root"
      direction="row"
      spacing={1}
      sx={deepmerge(shortInfoActionWrapper, sx)}
    >
      {isComingSoon ? (
        <Button
          size={buttonSize}
          disabled
          variant="contained"
          sx={comingSoonButton}
        >
          {t("Coming soon")}
        </Button>
      ) : (
        <Button
          variant="contained"
          startIcon={icon}
          size={buttonSize}
          {...restDirectionButtonProps}
          onClick={onNavigate}
          sx={{
            ...navigationButton,
            visibility: isHidden ? "hidden" : "visible",
          }}
        >
          {t(label)}
        </Button>
      )}
      {/* Remove Call button for now */}
      {/* {phone && <CallButton size={buttonSize} phoneNumber={phone} sx={actionButton} />} */}
      {navigator.share && (
        <ShareButton
          size={buttonSize}
          url={window.location.href}
          text={t("ShareButton.text")}
          {...ShareProps}
          sx={actionButton}
        />
      )}
      <Button sx={backButton} variant="contained" onClick={handleClickBack}>
        {closeIcon}
      </Button>
    </Stack>
  )
}
